<template>
<div class="campaign_wrap">
    <div v-for="item in items" :key="item.id">
      <a :href="'/campaign?id='+item.id" class="cam_btn">
          <p class="pc">キャンペーン開催中！</p>
          <p class="cam_content"><span>{{item.title | truncate(50) }}</span></p>
          <i class="material-icons">keyboard_arrow_right</i>
      </a>
    </div>
  <div class="spinner_area">
    <beat-loader :loading="isLoading" :color="'#ff6969'" :size="'12px'"></beat-loader>
  </div>
</div>
</template>

<script>
export default {
  // 初期値設定
  data() {
    return {
      total_count: 0,
      items: [],
      isLoading: false,
      requested: false,
      isLoading: false
    };
  },
  props: {
    held: {
      type:Boolean,
      default:true,
    },
    status: {
      type:Boolean,
      default:false,
    },
  },
  methods: {
    getPosts() {
      this.isLoading = true;
      const data = {
        is_held: this.held,
        is_public: this.status,
      };
      var self = this;
      axios
        .post("/api/campaigns",data)
        // 成功時処理
        .then(res => {
          self.requested = true;
          self.isLoading = false;
          self.items = self.items.concat(res.data.items);
          if (self.items.length > 0) {
            // 全レコード数を取得
            self.total_count = self.items[0].total_count;
          }
          self.startPost = Object.keys(self.items).length;
          //console.log(self.items);
        })
        // エラーレスポンス時処理
        .catch(error => {
          self.requested = true;
          self.isLoading = false;
          console.log(error);
        });
    },
  },
  created() {
    this.getPosts();
  }
};
</script>